export const categories = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    seq: 'cat-shoes-v2',
    query: 'Designer%20sneakers%20and%20leather%20shoes%20arranged%20on%20a%20warm%20terracotta%20ceramic%20tile%20surface%20with%20morning%20sunlight%20casting%20long%20soft%20shadows%2C%20premium%20product%20photography%2C%20minimalist%20Mediterranean%20aesthetic%2C%20rich%20textures%20on%20suede%20and%20leather',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    seq: 'cat-hoodies-v2',
    query: 'Oversized%20pastel%20hoodies%20and%20chunky%20knit%20sweaters%20artfully%20draped%20over%20a%20natural%20rattan%20chair%20against%20a%20soft%20sage%20green%20wall%2C%20cozy%20afternoon%20light%2C%20minimalist%20Scandinavian%20interior%2C%20textural%20fabric%20detail',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    seq: 'cat-tshirts-v2',
    query: 'Premium%20organic%20cotton%20t-shirts%20in%20earth%20tones%20neatly%20rolled%20and%20stacked%20on%20a%20bamboo%20shelf%2C%20zen%20minimalist%20aesthetic%2C%20soft%20diffused%20natural%20light%2C%20Japanese%20organizational%20style%2C%20clean%20and%20serene',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    seq: 'cat-jackets-v2',
    query: 'Vintage%20leather%20and%20denim%20jackets%20displayed%20on%20dark%20walnut%20wooden%20hangers%20against%20an%20exposed%20brick%20wall%2C%20warm%20industrial%20loft%20vibe%2C%20soft%20golden%20hour%20light%2C%20editorial%20fashion%20photography%2C%20textured%20urban%20aesthetic',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    seq: 'cat-pants-v2',
    query: 'Tailored%20linen%20trousers%20and%20casual%20shorts%20folded%20neatly%20on%20a%20light%20marble%20surface%20with%20a%20small%20potted%20olive%20tree%20nearby%2C%20Mediterranean%20minimalist%20aesthetic%2C%20bright%20natural%20daylight%2C%20crisp%20clean%20product%20photography',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    seq: 'cat-headwear-v2',
    query: 'Designer%20caps%20and%20wide%20brim%20hats%20styled%20on%20a%20smooth%20concrete%20pedestal%20in%20a%20bright%20white%20gallery%20space%2C%20contemporary%20art%20gallery%20aesthetic%2C%20soft%20overhead%20lighting%2C%20minimalist%20luxury%20display',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    seq: 'cat-sets-v2',
    query: 'Coordinated%20two-piece%20matching%20outfits%20displayed%20on%20a%20minimalist%20clothing%20rack%20with%20a%20warm%20beige%20backdrop%2C%20contemporary%20boutique%20display%20style%2C%20soft%20studio%20lighting%2C%20harmonious%20monochrome%20color%20palette%2C%20luxe%20minimalist%20editorial',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    seq: 'cat-underwear-v2',
    query: 'Soft%20modal%20cotton%20underwear%20in%20muted%20neutral%20tones%20folded%20and%20arranged%20on%20a%20white%20fluffy%20towel%20texture%20surface%2C%20spa-like%20serene%20atmosphere%2C%20gentle%20morning%20light%2C%20clean%20wellness%20aesthetic',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    seq: 'cat-jersey-v2',
    query: 'Professional%20sports%20jerseys%20in%20bold%20team%20colors%20hung%20on%20a%20locker%20room%20style%20metal%20rack%2C%20dynamic%20athletic%20aesthetic%2C%20dramatic%20side%20lighting%20highlighting%20mesh%20fabric%20texture%2C%20sportswear%20editorial%20photography',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    seq: 'cat-accessories-v2',
    query: 'Fashion%20accessories%20including%20minimalist%20watches%20and%20delicate%20jewelry%20scattered%20on%20a%20raw%20silk%20fabric%20surface%2C%20luxury%20editorial%20style%2C%20soft%20golden%20hour%20warm%20light%2C%20elegant%20and%20refined%20product%20photography',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    seq: 'cat-bags-v2',
    query: 'Designer%20backpacks%20and%20leather%20tote%20bags%20arranged%20on%20a%20sleek%20modern%20bookshelf%20against%20warm%20wood%20paneling%2C%20contemporary%20home%20library%20setting%2C%20soft%20reading%20lamp%20glow%2C%20sophisticated%20product%20photography',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    seq: 'cat-belts-v2',
    query: 'Premium%20leather%20belts%20with%20brass%20buckles%20artfully%20curled%20on%20a%20dark%20slate%20stone%20surface%2C%20masculine%20luxury%20aesthetic%2C%20dramatic%20side%20lighting%20creating%20deep%20shadows%2C%20craftsmanship%20detail%20photography',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    seq: 'cat-perfumes-v2',
    query: 'Elegant%20perfume%20bottles%20with%20golden%20accents%20placed%20on%20a%20vintage%20mirror%20tray%20with%20dried%20lavender%20sprigs%2C%20vanity%20table%20setting%2C%20soft%20candlelight%20ambiance%2C%20romantic%20luxury%20aesthetic%2C%20intimate%20product%20photography',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    seq: 'cat-other-v2',
    query: 'Eclectic%20mix%20of%20lifestyle%20products%20including%20stationery%20and%20decor%20items%20on%20a%20warm%20wooden%20desk%20with%20sunlight%20streaming%20through%20sheer%20curtains%2C%20creative%20studio%20vibe%2C%20organized%20chaos%20aesthetic%2C%20soft%20warm%20tones',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';